// Re-export standard Next.js navigation
export { redirect, usePathname, useRouter } from 'next/navigation'

// For Link, we keep it as-is from Next.js
export { default as Link } from 'next/link'
